import { Link } from "react-router-dom";
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  linkTo?: string;
  className?: string;
}
export const Logo = ({
  size = 'md',
  showText = true,
  linkTo,
  className = ""
}: LogoProps) => {
  const logoSizes = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10'
  };
  const LogoContent = () => <div className={`flex items-center ${className}`}>
      <img src="/lovable-uploads/e708caae-a428-4984-a95d-558fa0965b6c.png" alt="LeadExtract Logo" className={`${logoSizes[size]} mr-2`} />
      {showText && <div className="flex flex-col">
          
          
        </div>}
    </div>;
  if (linkTo) {
    return <Link to={linkTo} className="flex items-center">
        <LogoContent />
      </Link>;
  }
  return <LogoContent />;
};